import { jsxs as d, jsx as o } from "@emotion/react/jsx-runtime";
import { memo as O, useRef as m, useMemo as B, useEffect as D } from "react";
import { SIDEBAR_Z_INDEX as T } from "@partoohub/ui";
import { SidebarContainer as _, TopSection as H, LogoContainer as I, MenuContainer as j, Navigation as k, NavigationList as h, SidebarFooter as y } from "./Sidebar.styled.js";
import { useSidebarContext as A } from "./SidebarContext.js";
import { DynamicMenuRenderer as l } from "./subComponents/DynamicMenuRenderer/DynamicMenuRenderer.js";
import { ShowMore as G } from "./subComponents/ShowMore/ShowMore.js";
import { useClickOutside as W } from "../../hooks/useClickOutside.js";
import { useSidebarRoutes as z } from "../../hooks/useSidebarRoutes.js";
import { useWindowSize as F } from "../../hooks/useWindowSize.js";
import { PADDING_BETWEEN_UL_LOGO as P } from "./helpers.js";
const U = O(({
  children: f,
  logo: M,
  moreText: g,
  routes: p = [],
  zIndex: E = T
}) => {
  const {
    height: S
  } = F(), u = m(null), c = m(null), {
    sidebarRef: n,
    extended: r,
    setExtended: t,
    showMoreMenu: C,
    setShowMoreMenu: R
  } = A(), {
    topRoutes: v,
    bottomRoutes: b,
    showMoreRoutes: i
  } = z(p), L = !!(i?.length && i.length > 0), w = () => {
    t(!0);
  }, x = B(() => {
    const e = u?.current?.getBoundingClientRect().height ?? 0, s = c?.current?.getBoundingClientRect().height ?? 0;
    return e + s + P;
  }, [S]), N = () => {
    C || t(!1);
  }, a = () => {
    R(!1);
  };
  return D(() => {
    const e = (s) => {
      n.current && !n.current.contains(s.target) && t(!1);
    };
    return r ? document.addEventListener("touchend", e) : document.removeEventListener("touchend", e), () => {
      document.removeEventListener("touchend", e);
    };
  }, [r]), W({
    refs: [n],
    onClickOutside: () => t(!1)
  }), /* @__PURE__ */ d(_, { zIndex: E, extended: r, ref: n, onMouseEnter: w, onMouseLeave: N, children: [
    /* @__PURE__ */ o(H, { ref: u, children: /* @__PURE__ */ o(I, { children: M }) }),
    /* @__PURE__ */ d(j, { children: [
      /* @__PURE__ */ o(k, { ref: c, children: /* @__PURE__ */ d(h, { children: [
        v?.map((e) => /* @__PURE__ */ o(l, { route: e, handleCloseMenu: a }, e.name)),
        L && /* @__PURE__ */ o(G, { moreText: g, showMoreRoutes: i, maxHeightShowMoreMenu: x })
      ] }) }),
      /* @__PURE__ */ o(y, { children: /* @__PURE__ */ o(h, { children: b?.map((e) => /* @__PURE__ */ o(l, { route: e, handleCloseMenu: a }, e.name)) }) })
    ] }),
    f
  ] });
});
U.displayName = "Sidebar";
export {
  U as SidebarComponent
};
